import React from 'react';

const ErrorNotification = () => {
    return (
        <svg width={15} height={15} viewBox="0 0 15 15">
            <g
                data-name="x (1)"
                fill="none"
                stroke="#fafafa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            >
                <path data-name="Line 25" d="M15 0L0 15" />
                <path data-name="Line 26" d="M0 0l15 15" />
            </g>
        </svg>
    );
};

export default ErrorNotification;
